// extracted by mini-css-extract-plugin
export default {"game_board":"whack-mole-container_game_board__dr7sJ"};